import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from "../../atoms/dialog";
import RunSimulation from '../../molecules/simulations/RunSimulation';
import { useState } from 'react';

export default function RunSimulationDialog({ onClose, setOpenSimulationLogs }) {
    const [openAppView, setOpenAppView] = useState(false);

    const button = <Button onClick={onClose} variant="contained">Close</Button>;
    return (
        <Dialog
            title={"Run Simulation"}
            handleClose={() => onClose()}
            open={true}
            paperProps={{ style: { width: 1000, maxWidth: 1500 }, id: "runSimulationModal" }}
            openAppView={openAppView} 
            setOpenAppView={setOpenAppView}
            showAppViewOption
        >

            <RunSimulation onClose={onClose} setOpenSimulationLogs={setOpenSimulationLogs} />


        </Dialog>
    )
}